import { useOrderFormCalculation } from "@/modules/order/hooks/use-order-form-calculation.hook"
import useOrderFormParams from "@/modules/order/hooks/use-order-form-params.hook"
import { useOrderFormStore } from "@/modules/order/stores/order-form.store"
import { useEffect } from "react"

export function useAutoCalculateOrderFormJson() {
	const {autoCalculateEnabled} = useOrderFormParams()

	const {updatedProductDetails, jsonOrderForm, actions: {setUpdatedProductDetails}} = useOrderFormStore()
	const {calculateOrderForm, isCalculatingOrder} = useOrderFormCalculation()


	useEffect(() => {
		if(autoCalculateEnabled && updatedProductDetails) {
			calculateOrderForm(jsonOrderForm)
			setUpdatedProductDetails(false)
		}
	}, [jsonOrderForm.itemsCalculo])

	return {isCalculatingOrder}
}